module.exports = __webpack_public_path__ + "media/sub7-5-5.2697ca4c.mp4";